export default {
  app: {
    name: "体育博彩",
    full: "后台模板",
    minimized: "BO"
  },
  no_records: "无记录",
  welcome: "欢迎回来，{用户}！",
  login: "登录到您的账号。",
  login_success: "登入成功。",
  relogin: "请重新登录到您的账号。",
  expired: "时域已过期。",
  denied: "没有权限！",
  success: "您已成功完成！",
  select_date_range: "请选择日期",
  permission_denied: "您无权执行此操作！",
  search_by_id_name: "按ID或名称搜索",
  search_by_name: "按名称搜索",
  close: "账号已被关闭。请与您的管理员联系。",
  suspend: "账号已被暂停。 请与您的管理员联系。",
  suspend_alert1: "您的账号已更改为\"仅查看\".",
  suspend_alert2: "请咨询您的上线。",
  freeze: "账号已被冻结。 请与您的管理员联系。",
  account_id_length_error: "无效的账号ID长度。",
  change_user_status_confirm: "您确定要更改账号状态吗？",
  delete_confirm: "您确定要删除 \"{name}\"吗？",
  update_account_status_confirm: "您确定要更新账号状态吗？",
  update_account_status_cancel: "更新账号状态失败。",
  update_account_status_success: "账号状态已成功更新！",
  update_account_password_confirm: "您确定要更新账号密码吗？",
  update_account_password_cancel: "更新账号密码失败。",
  update_account_password_success: "密码更新成功！",
  update_account_password_success1: "密码已成功更新！请重新登录。",
  update_password_failed: "密码更新失败。",
  update_account_security_confirm: "您确定要更新账号安全性吗？",
  update_account_security_cancel: "更新账号安全性失败。",
  update_account_security_success: "账号安全性已成功更新！",
  update_account_authority_confirm: "您确定要更新账号授权吗？",
  update_account_authority_cancel: "更新账号权限失败。",
  update_account_authority_success: "账号权限已成功更新！",
  block_sub_account_confirm: "您确定要封锁子账号吗？",
  block_sub_account_cancel: "封锁子账号失败。",
  block_sub_account_success: "子账号已成功封锁！",
  unblock_sub_account_confirm: "您确定要解封子账号吗？",
  unblock_sub_account_cancel: "解封子账号失败。",
  unblock_sub_account_success: "子账号已成功解封！",
  successful_update_profile: "您已成功更新个人资料。",
  successful_update_security: "您已成功更新安全码。",
  successful_create_account: "您已成功创建新账号。",
  update_platform_settings_confirm: "您确定要更新平台设置吗？",
  update_platform_settings_cancel: "更新平台设置失败。",
  update_platform_settings_success: "平台设置已成功更新！",
  update_partner_sports_confirm: "您确定要更新合作伙伴运动设置吗？",
  update_partner_sports_cancel: "更新合作伙伴运动设置失败。",
  update_partner_sports_success: "合作伙伴运动设置已成功更新！",
  update_partner_market_confirm: "您确定要更新合作伙伴市场设置吗？",
  update_partner_market_cancel: "更新合作伙伴市场设置失败。",
  update_partner_market_success: "合作伙伴市场设置已成功更新！",
  update_partner_bet_type_confirm: "您确定要更新合作伙伴投注类型设置吗？",
  update_partner_bet_type_cancel: "更新合作伙伴投注类型设置失败。",
  update_partner_bet_type_success: "合作伙伴投注类型设置已成功更新！",
  partner_ldiff_margin_priority: "注意：LDiff / Margin 的优先级为 投注类型 > 市场类型 > 运动类型。进行任何更改时请留意此优先级。",
  reset_accumulate_win_confirm: "您确定要重置累积赢额上限吗？",
  reset_accumulate_win_cancel: "重置累积赢额上限失败。",
  reset_accumulate_win_success: "累积赢额上限成功重置！",
  parent_platform_disabled: "上线平台设置已被禁用。",
  copy_success: "账号信息已复制到剪贴板。",
  copy_failed: "您的浏览器不支持复制到剪贴板。",
  copy_all_upline: "复制足球HDP(让球)上线至所有运动类型。",
  copy_all_account: "复制足球HDP(让球)账号至所有运动类型",
  copy_all_remaining: "复制足球HDP(让球)保留至所有运动类型。",
  copy_all_min: "复制足球HDP(让球)最低至所有运动类型。",
  copy_all_min_bet: "复制足球最低投注至所有运动类型。",
  copy_all_max_bet: "复制足球最大投注至所有运动类型。",
  copy_all_max_per_match: "复制足球最大单注至所有运动类型。",
  create_secondary_account_success: "辅助账号已成功创建！ 请重新登录。",
  first_sub_account_success: "子账号已成功更新！ 请重新登录。",
  update_account_commission_confirm: "您确定要更新账号佣金吗？",
  update_account_commission_cancel: "更新账号佣金失败。",
  update_account_commission_success: "账号佣金已成功更新！",
  update_account_position_confirm: "您确定要更新账号PT(持仓)吗？",
  update_account_position_cancel: "更新账号PT(持仓)失败。",
  update_account_position_success: "账号PT(持仓)已成功更新。",
  update_account_bet_limit_confirm: "您确定要更新账号投注限额吗？",
  update_account_bet_limit_cancel: "更新账号投注限额失败。",
  update_account_bet_limit_success: "账号投注限额已成功更新！",
  update_account_profile_confirm: "您确定要更新账号资料吗？",
  update_account_profile_cancel: "更新账号资料失败。",
  update_account_profile_success: "账号资料已成功更新！",
  create_new_account_confirm: "您确定要创建新账号吗？",
  create_new_account_cancel: "创建新账号失败。",
  create_new_account_success: "新账号已成功创建！",
  create_sub_account_confirm: "您确定要创建子账号吗？",
  create_sub_account_cancel: "创建子账号失败。",
  create_sub_account_success: "子账号已成功创建！",
  update_sub_account_confirm: "您确定要更新子账号吗？",
  update_sub_account_cancel: "更新子账号失败。",
  update_sub_account_success: "子账号已成功更新！",
  unblock_account_profile_confirm: "您确定要解封账号资料吗？",
  unblock_account_profile_cancel: "解封账号资料失败。",
  unblock_account_profile_success: "账号资料已成功解封！",
  settlement_confirm: "您确定要进行结算吗？",
  settlement_cancel: "结算失败。",
  settlement_success: "结算成功处理！",
  settlement_not_allowed: "今天不允许结算！",
  search_with_working_date: "搜索于工作日。",
  system_error: "系统无法处理您的请求",
  invalid_password: "无效的用户名或密码。",
  invalid_account: "无效账户。",
  block: "您的账号已被封锁。",
  invalid_security_code: "无效的安全码。",
  source_account_id_required: "账号ID不能为空。",
  target_account_id_required: "目标账号ID不能为空。",
  account_id_required: "账号ID不能为空。",
  sub_login_id_required: "登入ID不能为空。",
  account_not_exists: "无效账号。",
  profile_not_exists: "无效账号。",
  account_inactive: "无效账号。",
  not_blocked_account: "有效账号。",
  password_required: "密码不能为空。",
  parent_id_required: "主级ID不能为空。",
  parent_not_exists:"无效账号。",
  invalid_account_type: "无效账号类型。",
  account_exists: "账号已存在。",
  login_id_required: "登入ID不能为空。",
  new_login_id_required: "新登入ID不能为空。",
  login_id_not_exists: "无效的登入ID。",
  invalid_authority_role: "无效角色。",
  profile_inactive: "无效个人资料。",
  secondary_account_exists: "辅助账号已存在。",
  secondary_id_acknowledge_checkbox: "我确认将在下次登录时使用辅助ID登录。",
  new_login_id_exists: "新登入ID已存在。",
  new_password_required: "新密码不能为空。",
  security_tag_required: "安全标签不能为空。",
  security_code_required: "安全码不能为空。",
  start_date_required: "开始日期不能为空。",
  end_date_required: "结束日期不能为空。",
  start_date_gt_end_date: "开始日期大于结束日期。",
  start_date_greater_end_date: "开始日期大于结束日期。",
  member_id_required: "会员ID不能为空。",
  currency_code_required: "货币代码不能为空。",
  commission_setting_not_exists: "佣金设置不存在。",
  incomplete_account_line: "账号路线不完整。",
  invalid_hdp_package: "无效的HDP(让球)配套。",
  search_id_required: "搜索ID不能为空。",
  profile_id_required: "资料ID不能为空。",
  login_not_exists: "登入ID无效。",
  no_changes: "无检测到更改。",
  start_date_require: "开始日期不能为空。",
  league_id_required: "联赛ID不能为空。",
  sport_type_required: "运动类型不能为空。",
  match_id_required: "赛事ID不能为空。",
  target_login_id_required: "目标登入ID不能为空。",
  parent_account_not_exists: "无效账号。",
  parent_account_inactive: "无效主级账号。",
  parent_profile_not_exists: "无效账号。",
  parent_profile_inactive: "无效主级资料。",
  target_login_id_not_exists: "无效账号。",
  incorrect_parent: "无效主级ID。",
  invalid_session: "无效时域请求。",
  session_expired: "时域已过期。",
  settle_amount_required: "结算金额不能为空。",
  invalid_settle_amount: "无效结算金额。",
  settle_amount_gt_yesterday_balance: "结算金额大于昨天余额。",
  invalid_account_status: "无效账号状态。",
  bet_limit_packages_required: "投注限额配套不能为空。",
  bet_limit_exists: "投注限额已存在。",
  member_bet_limit_package_gt_one: "会员投注限额配套多于一。",
  parent_bet_limit_not_exists: "主级投注限额不存在。",
  account_commission_required: "账号佣金不能为空。",
  commission_setting_exists: "佣金设置已存在。",
  parent_comm_not_exists: "主级佣金设置不存在。",
  exceeded_parent_comm: "超出了主级佣金设置。",
  others_commission_required: "其他佣金设置不能为空。",
  exceeded_parent_1x2: "超出主级的1x2佣金设置。",
  exceeded_parent_other: "超出主级其他佣金设置。",
  hdp_commission_required: "HDP（让球）佣金设置不能为空。",
  exceeded_parent_hdp_a: "超出主级HDP（A）佣金设置。",
  exceeded_parent_hdp_b: "超出主级HDP（B）佣金设置。",
  exceeded_parent_hdp_c: "超出主级HDP（C）佣金设置。",
  exceeded_parent_hdp_d: "超出主级HDP（D）佣金设置。",
  exceeded_parent_hdp_e: "超出主级HDP（E）佣金设置。",
  exceeded_parent_hdp_f: "超出主级HDP（F）佣金设置。",
  exceeded_parent_hdp_g: "超出主级HDP（G）佣金设置。",
  exceeded_parent_hdp_h: "超出主级HDP（H）佣金设置。",
  exceeded_parent_hdp_i: "超出主级HDP（I）佣金设置。",
  exceeded_parent_hdp_j: "超出主级HDP（J）佣金设置。",
  livecasino_upline_pt_required: "[真人娱乐场] 上线PT（持仓）设置不能为空。",
  livecasino_pt_setting_exists: "[真人娱乐场] PT（持仓）设置不能为空。",
  livecasino_parent_pt_not_exists: "[真人娱乐场] 主级PT（持仓）设置不存在。",
  livecasino_parent_min_not_meet: "[真人娱乐场] 与主级最低PT（持仓）不相符。",
  livecasino_exceeded_parent_pt: "[真人娱乐场] 超出主级PT（持仓）设置。",
  livecasino_account_pt_required: "[真人娱乐场] 账号PT（持仓）不能为空。",
  livecasino_upline_remaining_required: "[真人娱乐场] 上线保留PT（持仓）设置不能为空。",
  livecasino_account_min_required: "[真人娱乐场] 账号最低PT（持仓）设置不能为空。",
  livecasino_upline_remaining_gt_account_pt: "[真人娱乐场] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  livecasino_account_min_gt_p: "[真人娱乐场] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  slots_upline_pt_required: "[老虎机] 上线PT（持仓）设置不能为空。",
  slots_pt_setting_exists: "[老虎机] PT（持仓）设置不能为空。",
  slots_parent_pt_not_exists: "[老虎机] 主级PT（持仓）设置不存在。",
  slots_parent_min_not_meet: "[老虎机] 与主级最低PT（持仓）不相符。",
  slots_exceeded_parent_pt: "[老虎机] 超出主级PT（持仓）设置。",
  slots_account_pt_required: "[老虎机] 账号PT（持仓）不能为空。",
  slots_upline_remaining_required: "[老虎机] 上线PT（持仓）设置不能为空。",
  slots_account_min_required: "[老虎机] 账号最低PT（持仓）设置不能为空。",
  slots_upline_remaining_gt_account_pt: "[老虎机] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  slots_account_min_gt_pt: "[老虎机] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  lotto_upline_pt_required: "[乐透] 上线PT（持仓）设置不能为空。",
  lotto_pt_setting_exists: "[乐透] PT（持仓）设置不能为空。",
  lotto_parent_pt_not_exists: "[乐透] 主级PT（持仓）设置不存在。",
  lotto_parent_min_not_meet: "[乐透] 与主级最低PT（持仓）不相符。",
  lotto_exceeded_parent_pt: "[乐透] 超出主级PT（持仓）设置。",
  lotto_account_pt_required: "[乐透] 账号PT（持仓）不能为空。",
  lotto_upline_remaining_required: "[乐透] 上线PT（持仓）设置不能为空。",
  lotto_account_min_required: "[乐透] 账号最低PT（持仓）设置不能为空。",
  lotto_upline_remaining_gt_account_pt: "[乐透] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  lotto_account_min_gt_pt: "[乐透] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  keno_upline_pt_required: "[奇乐] 上线PT（持仓）设置不能为空。",
  keno_pt_setting_exists: "[奇乐] PT（持仓）设置不能为空。",
  keno_parent_pt_not_exists: "[奇乐] 主级PT（持仓）设置不存在。",
  keno_parent_min_not_meet: "[奇乐] 与主级最低PT（持仓）不相符。",
  keno_exceeded_parent_pt: "[奇乐] 超出主级PT（持仓）设置。",
  keno_account_pt_required: "[奇乐] 账号PT（持仓）不能为空。",
  keno_upline_remaining_required: "[奇乐] 上线PT（持仓）设置不能为空。",
  keno_account_min_required: "[奇乐] 账号最低PT（持仓）设置不能为空。",
  keno_upline_remaining_gt_account_pt: "[奇乐] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  keno_account_min_gt_pt: "[奇乐] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  cockfight_upline_pt_required: "[电子竞技2] 上线PT（持仓）设置不能为空。",
  cockfight_pt_setting_exists: "[电子竞技2] PT（持仓）设置不能为空。",
  cockfight_parent_pt_not_exists: "[电子竞技2] 主级PT（持仓）设置不存在。",
  cockfight_parent_min_not_meet: "[电子竞技2] 与主级最低PT（持仓）不相符。",
  cockfight_exceeded_parent_pt: "[电子竞技2] 超出主级PT（持仓）设置。",
  cockfight_account_pt_required: "[电子竞技2] 账号PT（持仓）不能为空。",
  cockfight_upline_remaining_required: "[电子竞技2] 上线PT（持仓）设置不能为空。",
  cockfight_account_min_required: "[电子竞技2] 账号最低PT（持仓）设置不能为空。",
  cockfight_upline_remaining_gt_account_pt: "[电子竞技2] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  cockfight_account_min_gt_pt: "[电子竞技2] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  cockfight_exceeded_parent_commission: "[电子竞技2] 账户佣金设置大于父佣金设置。",
  lottery_upline_pt_required: "[彩票] 上线PT（持仓）设置不能为空。",
  lottery_pt_setting_exists: "[彩票] PT（持仓）设置不能为空。",
  lottery_parent_pt_not_exists: "[彩票] 主级PT（持仓）设置不存在。",
  lottery_parent_min_not_meet: "[彩票] 与主级最低PT（持仓）不相符。",
  lottery_exceeded_parent_pt: "[彩票] 超出主级PT（持仓）设置。",
  lottery_account_pt_required: "[彩票] 账号PT（持仓）不能为空。",
  lottery_upline_remaining_required: "[彩票] 上线PT（持仓）设置不能为空。",
  lottery_account_min_required: "[彩票] 账号最低PT（持仓）设置不能为空。",
  lottery_upline_remaining_gt_account_pt: "[彩票] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  lottery_account_min_gt_pt: "[彩票] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  bet_type_required: "投注类型不能为空。",
  schedule_1_to_7_required: "结算日程不能为空。",
  schedule_exists: "结算日程不存在。",
  parent_schedule_not_exists: "主级结算日程不存在。",
  schedule_1_not_available: "星期一结算不可用。",
  schedule_2_not_available: "星期二结算不可用。",
  schedule_3_not_available: "星期三结算不可用。",
  schedule_4_not_available: "星期四结算不可用。",
  schedule_5_not_available: "星期五结算不可用。",
  schedule_6_not_available: "星期六结算不可用。",
  schedule_7_not_available: "星期日结算不可用。",
  credit_limit_required: "信用额度不能为空。",
  member_credit_limit_required: "会员信用额度不能为空。",
  wallet_exists: "账号已存在。",
  member_credit_limit_gt_credit_limit: "会员信用额度大于信用额度。",
  parent_wallet_not_exists: "账号不存在。",
  account_credit_limit_gt_parent: "账号信用额度大于主级信用额度。",
  member_credit_limit_gt_parent: "会员信用额度大于主级信用额度。",
  exceeded_credit_limit: "超出账号信用额度。",
  soccer_min_bet_required: "最低投注不能为空。",
  soccer_max_bet_required: "最大投注不能为空。",
  soccer_max_per_match_required: "最大单注不能为空。",
  soccer_bet_limit_exists: "投注限额已存在。",
  soccer_parent_bet_limit_not_exists: "主级投注限额不存在。",
  soccer_account_min_bet_lt_parent: "账号最低投注低于主级。",
  soccer_account_max_bet_gt_parent: "账号最大投注大于主级。",
  soccer_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  basketball_min_bet_required: "最低投注不能为空。",
  basketball_max_bet_required: "最大投注不能为空。",
  basketball_max_per_match_required: "最大单注不能为空。",
  basketball_bet_limit_exists: "投注限额已存在。",
  basketball_parent_bet_limit_not_exists: "主级投注限额不存在。",
  basketball_account_min_bet_lt_parent: "账号最低投注低于主级。",
  basketball_account_max_bet_gt_parent: "账号最大投注大于主级。",
  basketball_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  tennis_min_bet_required: "最低投注不能为空。",
  tennis_max_bet_required: "最大投注不能为空。",
  tennis_max_per_match_required: "最大单注不能为空。",
  tennis_bet_limit_exists: "投注限额已存在。",
  tennis_parent_bet_limit_not_exists: "主级投注限额不存在。",
  tennis_account_min_bet_lt_parent: "账号最低投注低于主级。",
  tennis_account_max_bet_gt_parent: "账号最大投注大于主级。",
  tennis_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  baseball_min_bet_required: "最低投注不能为空。",
  baseball_max_bet_required: "最大投注不能为空。",
  baseball_max_per_match_required: "最大单注不能为空。",
  baseball_bet_limit_exists: "投注限额已存在。",
  baseball_parent_bet_limit_not_exists: "主级投注限额不存在。",
  baseball_account_min_bet_lt_parent: "账号最低投注低于主级。",
  baseball_account_max_bet_gt_parent: "账号最大投注大于主级。",
  baseball_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  parlay_min_bet_required: "最低投注不能为空。",
  parlay_max_bet_required: "最大投注不能为空。",
  parlay_max_per_match_required: "最大单注不能为空。",
  parlay_bet_limit_exists: "投注限额已存在。",
  parlay_parent_bet_limit_not_exists: "主级投注限额不存在。",
  parlay_account_min_bet_lt_parent: "账号最低投注低于主级。",
  parlay_account_max_bet_gt_parent: "账号最大投注大于主级。",
  parlay_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  esports_min_bet_required: "最低投注不能为空。",
  esports_max_bet_required: "最大投注不能为空。",
  esports_max_per_match_required: "最大单注不能为空。",
  esports_bet_limit_exists: "投注限额已存在。",
  esports_parent_bet_limit_not_exists: "主级投注限额不存在。",
  esports_account_min_bet_lt_parent: "账号最低投注低于主级。",
  esports_account_max_bet_gt_parent: "账号最大投注大于主级。",
  esports_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  others_min_bet_required: "最低投注不能为空。",
  others_max_bet_required: "最大投注不能为空。",
  others_max_per_match_required: "最大单注不能为空。",
  others_bet_limit_exists: "投注限额已存在。",
  others_parent_bet_limit_not_exists: "主级投注限额不存在。",
  others_account_min_bet_lt_parent: "账号最低投注低于主级。",
  others_account_max_bet_gt_parent: "账号最大投注大于主级。",
  others_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  used_credit_gt_credit_limit: "已使用的信用额度大于信用额度。",
  bet_limit_setting_not_exists: "投注限额设置不存在。",
  parent_bet_limit_setting_not_exists: "主级投注限额设置不存在。",
  package_not_exists_in_parent: "主级投注限额配套设置不存在。",
  soccer_bet_limit_setting_not_exists: "足球投注限额设置不存在。",
  soccer_update_interval_violated: "违反更新间隔。",
  basketball_bet_limit_setting_not_exists: "篮球投注限额设置不存在。",
  basketball_update_interval_violated: "违反更新间隔。",
  tennis_bet_limit_setting_not_exists:"网球投注限额设置不存在。",
  tennis_update_interval_violated: "违反更新间隔。",
  baseball_bet_limit_setting_not_exists:"棒球投注限额设置不存在。",
  baseball_update_interval_violated: "违反更新间隔。",
  parlay_bet_limit_setting_not_exists:"混合过关投注限额设置不存在。",
  parlay_update_interval_violated: "违反更新间隔。",
  esports_bet_limit_setting_not_exists:"电子竞技投注限额设置不存在。",
  esports_update_interval_violated: "违反更新间隔。",
  others_bet_limit_setting_not_exists:"其他投注限额设置不存在。",
  others_update_interval_violated: "违反更新间隔。",
  soccer_parent_bet_limit_setting_not_exists: "足球主级投注限额设置不存在。",
  soccer_min_bet_lt_parent: "足球账号最低投注低于主级。",
  soccer_max_bet_gt_parent: "足球账号最大投注大于主级。",
  soccer_max_per_match_gt_parent: "足球账号最大单注大于主级。",
  basketball_parent_bet_limit_setting_not_exists: "篮球主级投注限额设置不存在。",
  basketball_min_bet_lt_parent: "篮球账号最低投注低于主级。",
  basketball_max_bet_gt_parent: "篮球账号最大投注大于主级。",
  basketball_max_per_match_gt_parent: "篮球账号最大单注大于主级。",
  tennis_parent_bet_limit_setting_not_exists: "网球主级投注限额设置不存在。",
  tennis_min_bet_lt_parent: "网球账号最低投注低于主级。",
  tennis_max_bet_gt_parent: "网球账号最大投注大于主级。",
  tennis_max_per_match_gt_parent: "网球账号最大单注大于主级。",
  baseball_parent_bet_limit_setting_not_exists: "棒球主级投注限额设置不存在。",
  baseball_min_bet_lt_parent: "棒球账号最低投注低于主级。",
  baseball_max_bet_gt_parent: "棒球账号最大投注大于主级。",
  baseball_max_per_match_gt_parent: "棒球账号最大单注大于主级。",
  parlay_parent_bet_limit_setting_not_exists: "混合过关主级投注限额设置不存在。",
  parlay_min_bet_lt_parent: "混合过关账号最低投注低于主级。",
  parlay_max_bet_gt_parent: "混合过关账号最大投注大于主级。",
  parlay_max_per_match_gt_parent: "混合过关账号最大单注大于主级。",
  esports_parent_bet_limit_setting_not_exists: "电子竞技主级投注限额设置不存在。",
  esports_min_bet_lt_parent: "电子竞技账号最低投注低于主级。",
  esports_max_bet_gt_parent: "电子竞技账号最大投注大于主级。",
  esports_max_per_match_gt_parent: "电子竞技账号最大单注大于主级。",
  others_parent_bet_limit_setting_not_exists: "电子竞技主级投注限额设置不存在。",
  others_min_bet_lt_parent: "电子竞技账号最低投注低于主级。",
  others_max_bet_gt_parent: "电子竞技账号最大投注大于主级。",
  others_max_per_match_gt_parent: "电子竞技账号最大单注大于主级。",
  update_interval_violated: "违反更新间隔。",
  exceeded_parent_others: "超出主级其他佣金设置。",
  exceeded_parent_hdp: "超出主级HDP（让球）投注限额设置。",
  no_information_available: "无有效信息。",
  request_processing: "正在处理请求...",
  new_login_id_format_error: "仅有从a到z和0到9的小写字母和数字可用。",
  account_id_format_error: "仅有从a到z和0到9的小写字母和数字可用。",
  inactive_account: "账号已被关闭/暂停。 请联系运营商。",

  sportsbook_account_pt_gt_92: "超资深代理持仓不能超过92%",
  pending_result: "等待结果",
  insufficient_balance: "余额不足",
  ok: "完成",
  settlement_warning: "警告：如果余额已全部转入，以下突出显示的会员将获得负投注信用，因此，他们损失的金额可能超过给定的信用额。",
  jackpot_alert: "所有单次累积奖池超过 MYR 100,000 (THB 1,000,000), WBET 将承担全部费用。",
  accumulate_alert: "当汇款完毕后，赢额限制将会重新归零。",
  filter_yesterday_balance: "显示昨天余额不等于0",

  soccer_hdp_account_pt_lt_downline: "[足球] 账号HDP PT（持仓）不能低于下线",
  soccer_1x2_account_pt_lt_downline: "[足球] 账号1X2 PT（持仓）不能低于下线",
  soccer_others_account_pt_lt_downline: "[足球] 账号Others PT（持仓）不能低于下线",
  soccer_hdp_exceeded_parent_pt: "[足球] 超出主级HDP PT（持仓）设置。",
  soccer_1x2_exceeded_parent_pt: "[足球] 超出主级1X2 PT（持仓）设置。",
  soccer_others_exceeded_parent_pt: "[足球] 超出主级Others PT（持仓）设置。",
  parlay_account_pt_lt_downline: "账号混合过关PT（持仓）不能低于下线",
  account_pt_lt_downline: "账号PT（持仓）不能低于下线",
  player_alert_tooltips: "（注意：只有信用低于最低赌注的显示会员。）",

  relogin_seconds: "请在 {timer} 秒后重新登录",
  relogin_hours: "请在 {timer} 小时后重新登录",
  relogin_tooltips: "如果您需要解锁账户的帮助，请联系客户服务支持。",
  last_modified_slot: "您上次修改的时间是 {oldTime}。 请在 {newTime} 重试。",

  account_min_gt_pt: "账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  account_min_required: "Account minimum PT setting is required.",
  account_pt_required: "Account PT setting is required.",
  agent_id_required: "Agent ID is required.",
  amount_required: "Amount is required.",
  at_least_one_schedule_required: "At least one schedule setting is required.",
  authority_option_required: "Authority option setting is required.",

  baseball_min_bet_gt_max_bet: "Baseball min bet greater than max bet.",
  baseball_max_bet_gt_max_per_match: "Baseball max bet greater than max per match.",
  basketball_max_bet_gt_max_per_match: "Basketball max bet greater than max per match.",
  basketball_min_bet_gt_max_bet: "Basketball min bet greater than max bet.",
  brand_name_required: "Brand name is required",
  client_ip_required: "Client IP is required",

  cockfight_bet_limit_exists: "[ESports2] Bet limit is already exists.",
  cockfight_bet_limit_packages_required: "[ESports2] Bet limit packages are required.",
  cockfight_commission_required: "[ESports2] Commission setting is required.",
  cockfight_commission_setting_exists: "[ESports2] Commission setting is exists.",
  cockfight_invalid_bet_limit_package: "[ESports2] Invalid bet limit packages.",
  cockfight_member_bet_limit_package_gt_one: "[ESports2] Member bet limit packages is more than one.",
  cockfight_parent_bet_limit_not_exists: "[ESports2] Parent bet limit does not exists.",
  cockfight_parent_commission_not_exists: "[ESports2] Parent commission does not exists.",

  credit_limit_gt_parent_member_credit_limit: "Credit limit greater than parent member credit limit.",
  downline_limit_exceeded: "Downline limit exceeed.",

  esports_max_bet_gt_max_per_match: "[ESports] Max bet greater than max per match.",
  esports_min_bet_gt_max_bet: "[ESports] Min bet greater than max bet.",

  exceeded_parent_parlay_a: "Exceeded parent parlay A PT setting.",
  exceeded_parent_parlay_b: "Exceeded parent parlay B PT setting.",
  exceeded_parent_pt: "Exceeded parent parlay PT setting.",

  hdp_account_min_gt_pt: "HDP account min greater than parent PT.",
  hdp_account_min_required: "HDP account min setting is required.",
  hdp_account_pt_required: "HDP account PT setting is required.",
  hdp_exceeded_parent_commission: "HDP exceeded parent commission.",
  hdp_exceeded_parent_pt: "HDP exceeded parent PT.",
  hdp_mmo_account_min_gt_pt: "HDP MMO account min greater than parent PT.",
  hdp_mmo_account_min_required: "HDP MMO account min setting is required.",
  hdp_mmo_account_pt_required: "HDP MMO account PT setting is required.",
  hdp_mmo_commission_required: "HDP MMO commission is required.",
  hdp_mmo_exceeded_parent_commission: "HDP MMO exceeded parent commission.",
  hdp_mmo_exceeded_parent_pt: "HDP MMO exceeded parent PT.",
  hdp_mmo_parent_min_not_meet: "HDP MMO does not match with parent minimum PT.",
  hdp_mmo_parent_pt_not_exists: "HDP MMO parent PT setting does not exists.",
  hdp_mmo_pt_setting_exists: "HDP MMO PT setting is exists.",
  hdp_mmo_upline_pt_required: "HDP MMO Upline PT setting is required.",
  hdp_mmo_upline_remaining_gt_account_pt: "HDP MMO Upline remaining PT setting is greater than account PT setting.",
  hdp_mmo_upline_remaining_required: "HDP MMO Upline remaining PT setting is required.",
  hdp_package_required: "HDP packages is required.",
  hdp_packages_not_exists: "HDP packages does not exists.",
  hdp_packages_required: "HDP packages is required.",
  hdp_parent_min_not_meet: "HDP does not match with parent minimum PT.",
  hdp_parent_pt_not_exists: "HDP parent PT setting does not exists.",
  hdp_pt_setting_exists: "HDP PT setting is exists.",
  hdp_required: "HDP is required.",
  hdp_upline_pt_required: "HDP Upline PT setting is required.",
  hdp_upline_remaining_gt_account_pt: "HDP Upline remaining PT setting is greater than account PT setting.",
  hdp_upline_remaining_required: "HDP Upline remaining PT setting is required.",

  inactive_profile: "Inactive profile.",
  incorrect_format: "Incorrect format.",
  invalid_amount: "Invalid amount.",
  invalid_baseball_max_bet: "Invalid baseball max bet.",
  invalid_baseball_max_per_match: "Invalid baseball max per match.",
  invalid_baseball_min_bet: "Invalid baseball min bet.",
  invalid_basketball_max_bet: "Invalid basketball max bet,",
  invalid_basketball_max_per_match: "Invalid basketball max per match.",
  invalid_basketball_min_bet: "Invalid basketball min bet.",
  invalid_esports_max_bet: "Invalid Esports max bet.",
  invalid_esports_max_per_match: "Invalid Esports max per match.",
  invalid_esports_min_bet: "Invalid Esports min bet.",
  invalid_method: "Invalid method.",
  invalid_others_max_bet: "Invalid others max bet.",
  invalid_others_max_per_match: "Invalid others max per match.",
  invalid_others_min_bet: "Invalid others min bet.",
  invalid_parlay_max_bet: "Invalid parlay max bet.",
  invalid_parlay_max_per_match: "Invalid parlay max per match.",
  invalid_parlay_min_bet: "Invalid parlay min bet.",
  invalid_soccer_max_bet: "Invalid soccer max bet.",
  invalid_soccer_max_per_match: "Invalid soccer max per match.",
  invalid_soccer_min_bet: "Invalid soccer min bet.",
  invalid_tennis_max_bet: "Invalid tennis max bet.",
  invalid_tennis_max_per_match: "Invalid tennis max per match.",
  invalid_tennis_min_bet: "Invalid tennis min bet.",

  keno_bet_limit_exists: "[Keno] Bet limit is already exists.",
  keno_bet_limit_packages_required: "[Keno] Bet limit packages are required.",
  keno_commission_required: "[Keno] Commission setting is required.",
  keno_commission_setting_exists: "[Keno] Commission setting is exists.",
  keno_exceeded_parent_commission: "[Keno] Account commission setting is greater than parent commission setting.",
  keno_invalid_bet_limit_package: "[Keno] Invalid bet limit packages.",
  keno_member_bet_limit_package_gt_one: "[Keno] Member bet limit packages is more than one.",
  keno_parent_bet_limit_not_exists: "[Keno] Parent bet limit does not exists.",
  keno_parent_commission_not_exists: "[Keno] Parent commission does not exists.",

  livecasino_account_min_gt_pt: "[Livecasino] Account minimum PT setting is greater than parent PT setting.",
  livecasino_bet_limit_exists: "[Livecasino] Bet limit is already exists.",
  livecasino_bet_limit_packages_required: "[Livecasino] Bet limit packages are required.",
  livecasino_commission_required: "[Livecasino] Commission setting is required.",
  livecasino_commission_setting_exists: "[Livecasino] Commission setting is exists.",
  livecasino_exceeded_parent_commission: "[Livecasino] Account commission setting is greater than parent commission setting.",
  livecasino_invalid_bet_limit_package: "[Livecasino] Invalid bet limit packages.",
  livecasino_member_bet_limit_package_gt_one: "[Livecasino] Member bet limit packages is more than one.",
  livecasino_parent_bet_limit_not_exists: "[Livecasino] Parent bet limit does not exists.",
  livecasino_parent_commission_not_exists: "[Livecasino] Parent commission does not exists.",

  login_ip_required: "Login IP is required.",
  lottery_1d_parent_min_not_meet: "[Lottery 1D] Does not match with parent minimum PT.",
  lottery_1d_account_min_gt_pt: "[Lottery 1D] Account minimum PT setting is greater than parent PT setting.",
  lottery_1d_account_min_required: "[Lottery 1D] Account minimum PT setting is required.",
  lottery_1d_account_pt_lt_downline: "[Lottery 1D] Account PT is lower than downline.",
  lottery_1d_account_pt_required: "[Lottery 1D] Account PT setting is required.",
  lottery_1d_commission_required: "[Lottery 1D] Commission setting is required.",
  lottery_1d_exceeded_parent_comm: "[Lottery 1D] Account commission setting is greater than parent commission setting.",
  lottery_1d_exceeded_parent_commission: "[Lottery 1D] Account commission setting is greater than parent commission setting.",
  lottery_1d_exceeded_parent_pt: "[Lottery 1D] Exceeded parent PT setting.",
  lottery_1d_pt_setting_exists: "[Lottery 1D] Parent PT setting is exists.",
  lottery_1d_parent_pt_not_exists: "[Lottery 1D] Parent PT setting does not exists.",
  lottery_1d_pt_setting_not_exists: "[Lottery 1D] PT setting does not exists.",
  lottery_1d_upline_pt_required: "[Lottery 1D] Upline PT setting is required.",
  lottery_1d_upline_remaining_gt_account_pt: "[Lottery 1D] Upline remaining PT setting is greater than account PT setting.",
  lottery_1d_upline_remaining_required: "[Lottery 1D] Upline remaining PT setting is required.",

  lottery_2d_account_min_gt_pt: "[Lottery 2D] Account minimum PT setting is greater than parent PT setting.",
  lottery_2d_account_min_required: "[Lottery 2D] Account minimum PT setting is required.",
  lottery_2d_account_pt_lt_downline: "[Lottery 2D] Account PT is lower than downline.",
  lottery_2d_account_pt_required: "[Lottery 2D] Account PT setting is required.",
  lottery_2d_commission_required: "[Lottery 2D] Commission setting is required.",
  lottery_2d_exceeded_parent_comm: "[Lottery 2D] Account commission setting is greater than parent commission setting.",
  lottery_2d_exceeded_parent_commission: "[Lottery 2D] Account commission setting is greater than parent commission setting.",
  lottery_2d_exceeded_parent_pt: "[Lottery 2D] Exceeded parent PT setting.",
  lottery_2d_parent_min_not_meet: "[Lottery 2D] Does not match with parent minimum PT.",
  lottery_2d_parent_pt_not_exists: "[Lottery 2D] Parent PT setting does not exists.",
  lottery_2d_pt_setting_exists: "[Lottery 2D] Parent PT setting is exists.",
  lottery_2d_pt_setting_not_exists: "[Lottery 1D] PT setting does not exists.",
  lottery_2d_upline_pt_required: "[Lottery 2D] Upline PT setting is required.",
  lottery_2d_upline_remaining_gt_account_pt: "[Lottery 2D] Upline remaining PT setting is greater than account PT setting.",
  lottery_2d_upline_remaining_required: "[Lottery 2D] Upline remaining PT setting is required.",

  lottery_3d_commission_required: "[Lottery 3D] Commission setting is required.",
  lottery_3d_exceeded_parent_comm: "[Lottery 3D] Account commission setting is greater than parent commission setting.",
  lottery_3d_exceeded_parent_commission: "[Lottery 3D] Account commission setting is greater than parent commission setting.",
  lottery_4d_commission_required: "[Lottery 4D] Commission setting is required.",
  lottery_4d_exceeded_parent_comm: "[Lottery 4D] Account commission setting is greater than parent commission setting.",
  lottery_4d_exceeded_parent_commission: "[Lottery 4D] Account commission setting is greater than parent commission setting.",
  lottery_bet_limit_exists: "[Lottery] Bet limit is already exists.",
  lottery_bet_limit_packages_required: "[Lottery] Bet limit packages are required.",
  lottery_commission_setting_exists: "[Lottery] Commission setting is exists.",
  lottery_invalid_bet_limit_package: "[Lottery] Invalid bet limit packages.",
  lottery_member_bet_limit_package_gt_one: "[Lottery] Member bet limit packages is more than one.",
  lottery_parent_bet_limit_not_exists: "[Lottery] Parent bet limit does not exists.",
  lottery_parent_commission_not_exists: "[Lottery] Parent commission does not exists.",

  lotto_bet_limit_exists: "[Lotto] Bet limit is already exists.",
  lotto_bet_limit_packages_required: "[Lotto] Bet limit packages are required.",
  lotto_commission_required: "[Lotto] Commission setting is required.",
  lotto_commission_setting_exists: "[Lotto] Commission setting is exists.",
  lotto_exceeded_parent_commission: "[Lotto] Account commission setting is greater than parent commission setting.",
  lotto_invalid_bet_limit_package: "[Lotto] Invalid bet limit packages.",
  lotto_member_bet_limit_package_gt_one: "[Lotto] Member bet limit packages is more than one.",
  lotto_parent_bet_limit_not_exists: "[Lotto] Parent bet limit does not exists.",
  lotto_parent_commission_not_exists: "[Lotto] Parent commission does not exists.",

  method_required: "Method is required.",
  no_accumulate_win: "No accumulated win.",

  one_x_two_account_min_gt_pt: "[1X2] Account minimum PT setting is greater than parent PT setting.",
  one_x_two_account_min_required: "[1X2] Account minimum PT setting is required.",
  one_x_two_account_pt_required: "[1X2] Account PT setting is required.",
  one_x_two_commission_required: "[1X2] Commission setting is required.",
  one_x_two_exceeded_parent_commission: "[1X2] Account commission setting is greater than parent commission setting.",
  one_x_two_exceeded_parent_pt: "[1X2] Exceeded parent PT setting.",
  one_x_two_parent_min_not_meet: "[1X2] Does not match with parent minimum PT.",
  one_x_two_parent_pt_not_exists: "[1X2] Parent PT setting does not exists.",
  one_x_two_pt_setting_exists: "[1X2] PT setting does not exists.",
  one_x_two_upline_pt_required: "[1X2] Upline PT setting is required.",
  one_x_two_upline_remaining_gt_account_pt: "[1X2] Upline remaining PT setting is greater than account PT setting.",
  one_x_two_upline_remaining_required: "[1X2] Upline remaining PT setting is required.",

  others_account_min_gt_pt: "[Others] Account minimum PT setting is greater than parent PT setting.",
  others_account_min_required: "[Others] Account minimum PT setting is required.",
  others_account_pt_required: "[Others] Account PT setting is required.",
  others_exceeded_parent_commission: "[Others] Account commission setting is greater than parent commission setting.",
  others_exceeded_parent_pt: "[Others] Exceeded parent PT setting.",
  others_max_bet_gt_max_per_match: "[Others] Max bet is greater than max per match,",
  others_min_bet_gt_max_bet: "[Others] Min bet greater than max bet.",
  others_parent_min_not_meet: "[Others] Does not match with parent minimum PT.",
  others_parent_pt_not_exists: "[Others] Parent PT setting does not exists.",
  others_pt_setting_exists: "[Others] PT setting does not exists.",
  others_upline_pt_required: "[Others] Upline PT setting is required.",
  others_upline_remaining_gt_account_pt: "[Others] Upline remaining PT setting is greater than account PT setting.",
  others_upline_remaining_required: "[Others] Upline remaining PT setting is required.",

  parent_hdp_packages_not_exists: "HDP packages does not exists.",
  parent_pt_not_exists: "Parent PT setting does not exists.",
  parent_setting_not_exists: "PT setting does not exists.",
  parlay_a_commission_required: "[Parlay A] Commission setting is required.",
  parlay_a_exceeded_parent_commission: "[Parlay A] Account commission setting is greater than parent commission setting.",
  parlay_a_required: "[Parlay A] Setting is required.",
  parlay_account_min_gt_pt: "[Parlay] Account minimum PT setting is greater than parent PT setting.",
  parlay_account_min_required: "[Parlay] Account minimum PT setting is required.",
  parlay_account_pt_required: "[Parlay] Account PT setting is required.",
  parlay_b_commission_required: "[Parlay B] Commission setting is required.",
  parlay_b_exceeded_parent_commission: "[Parlay B] Account commission setting is greater than parent commission setting.",
  parlay_b_required: "[Parlay B] Setting is required.",
  parlay_exceeded_parent_pt: "[Parlay] Exceeded parent PT setting.",
  parlay_max_bet_gt_max_per_match: "[Parlay] Max bet greater than max per match.",
  parlay_min_bet_gt_max_bet: "[Parlay] Min bet greater than max bet.",
  parlay_mmo_account_min_gt_pt: "[Parlay MMO] Account minimum PT setting is greater than parent PT setting.",
  parlay_mmo_account_min_required: "[Parlay MMO] Account minimum PT setting is required.",
  parlay_mmo_account_pt_required: "[Parlay MMO] Account PT setting is required.",
  parlay_mmo_exceeded_parent_pt: "[Parlay MMO] Exceeded parent PT setting.",
  parlay_mmo_parent_min_not_meet: "[Parlay MMO] Does not match with parent minimum PT.",
  parlay_mmo_parent_pt_not_exists: "[Parlay MMO] Parent PT setting does not exists.",
  parlay_mmo_pt_setting_exists: "[Parlay MMO] PT setting does not exists.",
  parlay_mmo_upline_pt_required: "[Parlay MMO] Upline PT setting is required.",
  parlay_mmo_upline_remaining_gt_account_pt: "[Parlay MMO] Upline remaining PT setting is greater than account PT setting.",
  parlay_mmo_upline_remaining_required: "[Parlay MMO] Upline remaining PT setting is required.",
  parlay_parent_min_not_meet: "[Parlay] Does not match with parent minimum PT.",
  parlay_parent_pt_not_exists: "[Parlay] Parent PT setting does not exists.",
  parlay_pt_setting_exists: "[Parlay] PT setting does not exists.",
  parlay_pt_setting_not_exists: "[Parlay] PT setting does not exists.",
  parlay_upline_pt_required: "[Parlay] Upline PT setting is required.",
  parlay_upline_remaining_gt_account_pt: "[Parlay] Upline remaining PT setting is greater than account PT setting.",
  parlay_upline_remaining_required: "[Parlay] Upline remaining PT setting is required.",
  platform_code_required: "Platform code is required.",
  platform_name_required: "Platform name is required.",
  pt_setting_not_exists: "PT setting does not exists.",

  result_id_required: "Result ID is required.",
  schedule_not_exists: "Schedule does not exists.",

  slots_commission_required: "[Slots] Commission setting is required.",
  slots_commission_setting_exists: "[Slots] Commission setting is exists.",
  slots_exceeded_parent_commission: "[Slots] Account commission setting is greater than parent commission setting.",
  slots_parent_commission_not_exists: "[Slots] Parent commission does not exists.",

  soccer_1x2_account_min_gt_pt: "[1X2] Account minimum PT setting is greater than parent PT setting.",
  soccer_1x2_account_min_required: "[1X2] Account minimum PT setting is required.",
  soccer_1x2_account_pt_required: "[1X2] Account PT setting is required.",
  soccer_1x2_parent_pt_not_exists: "[1X2] Parent PT setting does not exists.",
  soccer_1x2_pt_setting_not_exists: "[1X2] PT setting does not exists.",
  soccer_1x2_upline_pt_required: "[1X2] Upline PT setting is required.",
  soccer_1x2_upline_remaining_gt_account_pt: "[1X2] Upline remaining PT setting is greater than account PT setting.",
  soccer_1x2_upline_remaining_required: "[1X2] Upline remaining PT setting is required.",
  soccer_hdp_account_min_gt_pt: "[HDP] Account minimum PT setting is greater than parent PT setting.",
  soccer_hdp_account_min_required: "[HDP] Account minimum PT setting is required.",
  soccer_hdp_account_pt_required: "[HDP] Account PT setting is required.",
  soccer_hdp_parent_pt_not_exists: "[HDP] Parent PT setting does not exists.",
  soccer_hdp_pt_setting_not_exists: "[HDP] PT setting does not exists.",
  soccer_hdp_upline_pt_required: "[HDP] Upline PT setting is required.",
  soccer_hdp_upline_remaining_gt_account_pt: "[HDP] Upline remaining PT setting is greater than account PT setting.",
  soccer_hdp_upline_remaining_required: "[HDP] Upline remaining PT setting is required.",
  soccer_max_bet_gt_max_per_match: "[Soccer] Max bet greater than max per match.",
  soccer_min_bet_gt_max_bet: "[Soccer] Min bet greater than max bet.",
  soccer_others_account_min_gt_pt: "[Others] Account minimum PT setting is greater than parent PT setting.",
  soccer_others_account_min_required: "[Others] Account minimum PT setting is required.",
  soccer_others_account_pt_required: "[Others] Account PT setting is required.",
  soccer_others_parent_pt_not_exists: "[Others] Parent PT setting does not exists.",
  soccer_others_pt_setting_not_exists: "[Others] PT setting does not exists.",
  soccer_others_upline_pt_required: "[Others] Upline PT setting is required.",
  soccer_others_upline_remaining_gt_account_pt: "[Others] Upline remaining PT setting is greater than account PT setting.",
  soccer_others_upline_remaining_required: "[Others] Upline remaining PT setting is required.",

  sportsbook_commission_setting_exists: "[Sportsbook] Commission setting is exists.",
  sportsbook_mmo_commission_setting_exists: "[Sportsbook MMO] Commission setting is exists.",
  sportsbook_mmo_parent_commission_not_exists: "[Sportsbook MMO] Parent commission setting does not exists.",
  sportsbook_parent_commission_not_exists: "[Sportsbook] Parent ommission setting does not exists.",
  status_required: "Status is required.",
  sub_not_exists: "Sub-account does not exists.",

  target_profile_id_required: "Target profile ID is required.",
  tennis_max_bet_gt_max_per_match: "[Tennis] Max bet greater than max per match.",
  tennis_min_bet_gt_max_bet: "[Tennis] Min bt greater than max bet.",
  tournament_commission_required: "Tournament commission is required.",
  tournament_commission_setting_exists: "Tournament commission setting is exists.",
  tournament_exceeded_parent_commission: "Tournament parent commission exceeeded.",
  tournament_parent_commission_not_exists: "Tournament parent commission does not exits.",

  upline_pt_required: "Upline PT setting is required.",
  upline_remaining_gt_account_pt: "Upline remaining PT setting is greater than account PT setting.",
  upline_remaining_required: "Upline remaining PT setting is required.",
  wallet_not_exists: "Wallet does not exists.",
  working_date_required: "Working date is required.",
  password_expired_alert: "您的密码已过期。请重置您的密码。",

  cs_min_bet_lt_soccer: "Minimum bet is lower than soccer minimum bet.",
  cs_max_bet_gt_soccer: "Maximum bet is greater than soccer maximum bet.",
  cs_max_per_match_gt_soccer: "Maximum bet per match is greater than soccer match per match.",
  cs_tooltips: "正确比分投注限额仅符合足球投注限额",

  contact_phone_format_error: "联系电话格式无效",
  contact_email_format_error: "联系电子邮件格式无效",

  "notice": "<div style='text-align: left;'><b><u>通知: 关于Evolution Casino投注限额的更新</u></b><br><br>尊敬的代理商,<br><br>我们在此通知您，从2025年1月31日起，<b>Evolution Casino将不再支持公司规定的投注限额</b>。此调整意味着平台将不再限制投注金额，从而使操作更加灵活。<br><br>感谢您对这一变化的理解和持续合作。如有任何疑问，请随时联系我们的支持团队。<br><br>感谢您的合作。</div>",

  // OTP 2FA Messages
  other_authenticator_apps_supported: "其他双因素身份验证应用程序（如Sophos、Microsoft Authenticator等）也受支持",
  date_time_automatic_required: "您设备上的日期和时间设置必须设置为自动。",
  get_otp_2fa_qr_code_failed: "获取OTP 2FA QR码失败。请重试。",
  enter_secret_manually: "在您的身份验证应用中手动输入此密钥",
  otp_setup_failed: "设置OTP失败。请重试。",
  otp_verification_failed: "验证码无效。请重试。",
  otp_2fa_bound: "Google Authenticator已成功绑定到您的账户。",
  invalid_code: "验证码无效。请检查验证码并重试。",
  code_required: "请输入6位验证码。",
  otp_unbind_success: "OTP已成功解除绑定。",
  otp_unbind_failed: "解除OTP 2FA失败。请重试。",

  // Telegram OTP Messages
  telegram_chatbot_description: "Telegram Chatbot允许您方便且安全地接收重要业务报告，而无需访问代理网站。现在您还可以通过启用Telegram OTP通知，轻松通过Telegram Chatbot获取OTP。",
  telegram_setup_instructions: "要设置Chatbot，请按照以下说明操作：",
  telegram_setup_failed: "设置Telegram失败。请重试。",
  telegram_otp_bound: "Telegram OTP已成功启用。",
  unbind_otp_confirm: "您确定要解除OTP绑定吗？",
  telegram_otp_sent: "OTP代码已发送到您的Telegram",
  telegram_otp_request_failed: "请求OTP失败。请重试。",
  otp_unbind_first_to_use_other: "如果您想\"{module}\"，请先解除绑定。",  
  invalid_parameter: "参数无效。",
  remark_format_error: "备注格式错误。",
  date_range_exceed: "日期范围超过最大允许范围。",

  password_length_error: "密码必须至少8个字符。",
  password_whitespace_error: "密码不能包含前导或尾随空格。",
  password_types_error: "密码必须至少包含3种字符类型。",
  password_consecutive_error: "密码不能包含连续的字符/数字。",
  password_repeated_error: "密码不能包含重复的字符。",
  password_common_error: "密码不能包含常见单词。",
  
  security_code_required: "安全码是必需的。",
  security_code_error: "安全码必须正好6位数字。",
  security_digit_error: "安全码必须至少包含2个不同的数字。",
  security_consecutive_error: "安全码不能包含连续数字。",
  security_repeated_error: "安全码不能包含重复模式。",
  security_palindrome_error: "安全码不能是回文。",
  security_weak_error: "安全码强度太弱。",
  security_code_example: "例如: 123456, 765432, 456789, 等是不允许的。",

  account_action_log_alert: "在过去7天内，与该账户关联的账户的密码发生了变化。",
  unknown_error: "未知错误。"
};
